<template>
  <div class="service-area pt--70 pb--50 bg_color--1">
    <v-container>
      <v-row>
        <v-col md="8" offset-md="2" cols="12">
          <div class="text-center section-title mb--30">
            <h2 class="heading-title">Register your property</h2>
            <p class="description">
              Please use the form below to tell us more about your property.<br>
              Once completed, one of our team members will be in contact with
              you.
            </p>
          </div>
        </v-col>
      </v-row>
      <v-row class="service-main-wrapper bg-white--service">
        <v-col md="8" offset-md="2" cols="12">
          <PropertyForm />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import PropertyForm from "../components/PropertyForm";
export default {
  components: {
    PropertyForm,
  },
};
</script>
